export const shouldRenderLiveUpdatesIndicator = (args: {
  isLoggedIn: boolean;
  isSubscriptionPages: boolean;
  connected: boolean;
  isLiveUpdatesSupported: boolean;
  isLiveUpdatesEnabled: boolean;
}) => {
  const {
    isLoggedIn,
    isSubscriptionPages,
    connected,
    isLiveUpdatesSupported,
    isLiveUpdatesEnabled,
  } = args;
  if (isLoggedIn && isSubscriptionPages && connected) {
    if (isLiveUpdatesSupported && isLiveUpdatesEnabled === false) {
      return false;
    }

    return true;
  }

  return false;
};
